import ErrorFallback from 'components/error-fallback/ErrorFallback';
import { Column, ColumnProps } from 'primereact/column';
import { DataTableValueArray } from 'primereact/datatable';
import { ErrorBoundary } from 'react-error-boundary';
import styled from 'styled-components';

import { DataTableStyled } from '../StyledGrid';

interface ColumnPropsExtended extends ColumnProps {
  isDataReadonly?: boolean;
  isTitleReadonly?: boolean;
  placeholder?: string;
}

type TProps = {
  value?: DataTableValueArray | undefined;
  columns?: ColumnPropsExtended[] | undefined;
  className?: string;
};

const FixedGridPdf = ({ value, columns, className }: TProps) => {
  return (
    <ErrorBoundary FallbackComponent={ErrorFallback}>
      <div>
        <DataTableStyledHeader
          className={className}
          value={value}
          dataKey="id"
          tableStyle={{ minWidth: '49rem' }}
          style={{ overflow: 'auto', display: 'grid' }}
          showGridlines
        >
          {columns?.map((x) => (
            <Column key={x.field} {...x} />
          ))}
        </DataTableStyledHeader>
      </div>
    </ErrorBoundary>
  );
};

const DataTableStyledHeader = styled(DataTableStyled)`
  &.p-datatable .p-column-header-content {
    display: block;
  }
`;

export default FixedGridPdf;
